module.exports = __webpack_public_path__ + "static/img/title.a7b01b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title.png
// module id = Cb4U
// module chunks = 1